// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import BluebirdPromise from 'bluebird'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import elLocale from 'element-ui/lib/locale/lang/el'
import App from './App'
import router from './router'
import axios from 'axios'
// import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import messages from './messages.js'
import store from './store'

// import vuetron from 'vuetron'

// Vue.use(vuetron.VuetronVue)

//
// Internet Explorer support
//

// IE doesn't support promises
if (!window.Promise) {
  window.Promise = BluebirdPromise
}
// window.onbeforeunload = function () {
//   return 'Are you sure you want to close the window?'
// }
// IE doesn't support the method Array.includes()
// We are injecting it here while disabling the linter
// just for this line
if (!Array.prototype.includes) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.includes = function(str) {
    return this.indexOf(str) !== -1
  }
}

if (!Array.prototype.find) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.find = function(predicate) {
    // 1. Let O be ? ToObject(this value).
    if (this == null) {
      throw new TypeError('"this" is null or not defined')
    }

    var o = Object(this)

    // 2. Let len be ? ToLength(? Get(O, "length")).
    var len = o.length >>> 0

    // 3. If IsCallable(predicate) is false, throw a TypeError exception.
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function')
    }

    // 4. If thisArg was supplied, let T be thisArg else let T be undefined.
    var thisArg = arguments[1]

    // 5. Let k be 0.
    var k = 0

    // 6. Repeat, while k < len
    while (k < len) {
      // a. Let Pk be ! ToString(k).
      // b. Let kValue be ? Get(O, Pk).
      // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
      // d. If testResult is true, return kValue.
      var kValue = o[k]
      if (predicate.call(thisArg, kValue, k, o)) {
        return kValue
      }
      // e. Increase k by 1.
      k++
    }

    // 7. Return undefined.
    return undefined
  }
}

Vue.use(ElementUI, { elLocale, enLocale })
Vue.config.productionTip = false
Vue.config.performance = true
Vue.use(VueI18n)
locale.use(elLocale)
Vue.config.lang = 'el'
// Vue.locale('el', elLocale)
// Vue.locale('en', enLocale)
// function getAuthToken () {
//   // if the current store token expires soon
//   if (jwt(store.getters['auth/token']).exp - 240 <= (Date.now() / 1000).toFixed(0)) {
//     // if not already requesting a token
//     if (authTokenRequest === null) {
//       authTokenRequest = axios.post('/auth/refresh', {}, { withCredentials: true })
//         .then(response => {
//           // request complete and store
//           resetAuthTokenRequest()
//           store.commit('auth/refresh', response.data.access_token)
//           return response.data.access_token
//         })
//     }
//     return authTokenRequest
//   }
//   return store.getters['auth/token']
// }

// // tokenRequest dirty bit reseter
// function resetAuthTokenRequest() {
//   authTokenRequest = null
// }
axios.interceptors.request.use(req => {
  req.headers.common['Content-type'] = 'application/json'
  req.headers.common['Authorization'] = 'Bearer ' + sessionStorage.token
  req.headers.common['Content-Language'] = i18n.locale
  // config.headers['Authorization'] = 'Bearer ' + await getAuthToken()
  // Important: request interceptors **must** return the request.
  return req
})
// // Axios Intercept Requests
// axios.interceptors.request.use(
//   async function (config) {
//   // If not one of these specific pages that doesn't need a token, use method to get the current token or request a new one.  Otherwise, use current token (possibly none)
//     if (!config.url.includes('login') && !config.url.includes('refresh') && !config.url.includes('forgot_password') && !config.url.includes('reset_password') && !config.url.includes('activate')) {
//       config.headers['Authorization'] = 'Bearer ' + await getAuthToken()
//     } else {
//       config.headers['Authorization'] = 'Bearer ' + store.getters['auth/token']
//     }
//     return config
//   },
//   function (error) {
//     return Promise.reject(error)
//   }
// )
// -- For putting the token into every header by default
// if (sessionStorage.token) {
// console.log(i18n)
// axios.defaults.headers.common['X-Locale'] = i18n.locale
// }
// -- For intercepting every rsponse and detect 401 due to expired access token
// axios.interceptors.response.use(
//   (response) => {
// console.log(response)
//   return response
// },
// async (error) => {
// let request = error.config
// console.log(error.response.data)
// let tempMessage = ''
// Object.keys(error.response.data.message).forEach(key => {
//   tempMessage += error.response.data.message[key].reduce((acc, cur) =>
//     acc.slice(0, -1) + ', ' + cur.slice(0, -1))
// })
// tempMessage = tempMessage + '.'
// this.$notify({
//   title: 'Προειδοποίηση',
//   message: tempMessage,
//   offset: 100
// })
// if (error.response.data.message === 'The given data was invalid.') {
//   // alert(error.response.data.message)
//   router.replace('/')
//   router.replace('/login')
//   this.$notify.warning({
//     title: 'Προειδοποίηση',
//     message: error.response.data.message,
//     offset: 100
//   })
// }
// we need to prevent endless redirects. Login is where you should end up after one refresh try
// if (error.response.status === 401 && error.response.data.error === 'Invalid Access Token' && !request._retry) {
// if (error.response.status === 401) {
//   request._retry = true
//   try {
//     const response = await store.dispatch('refresh')
//     return axios(response)
//   } catch (error) {
//     // All Vuex modules must logout here
//     await store.dispatch('logout')
//     return Promise.reject(error)
//   }
// }
// return Promise.reject(error)
// })

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'el', // set locale
  messages, // set locale messages
})
Object.defineProperty(Vue.prototype, '$locale', {
  get: () => {
    return this.i18n.locale
  },
  set: locale => {
    this.i18n.locale = locale
  },
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  i18n,
  components: { App },
  template: '<App/>',
})
